import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Layout, Progress, Modal } from 'antd';
import Button from '@mui/material/Button';
import { actions, selectLatestLargeDataModel } from '../../Store/slices/largeDataAnalytics.slice'; // Adjust the import path as needed
import NivoScatterChart from "../../charts/nivo/NivoScatterChart";
import {COLD_PALETTE} from "../../utils/colorUtils";
import NivoBarChart from "../../charts/nivo/NivoBarChart";
import {useGptResponses} from "../../hooks/useGptResponses";
import TickerSearch from "../../Components/TickerSearch/TickerSearch";
import PageHeader from "../../Components/PageHeader";


const AttributionPair = ({feature, target, gridValues, pdepValues, confi})=>{
  if (!gridValues || !pdepValues){
    return null;
  }
  const strippedGrid  = gridValues.map(x=>x[0]);
  const pdepSeries = [...strippedGrid].map((x, i)=>{
    return {
      x: x,
      y: pdepValues[i]
    }
  });
  const confiLowSeries = [...strippedGrid].map((x, i)=>{
    return {
      x: x,
      y: confi[i][0]
    }
  });
  const confiHighSeries = [...strippedGrid].map((x, i)=>{
    return {
      x: x,
      y: confi[i][1]
    }
  })
  const chartData = [
    {
      id: 'Partial Dependence',
      data: pdepSeries
    },
    {
      id: 'Confidence Interval Low',
      data: confiLowSeries
    },
    {
      id: 'Confidence Interval High',
      data: confiHighSeries
    }
  ]
  const colorMapping = {
    'Partial Dependence': 'rgb(0, 0, 255)',
    'Confidence Interval Low': 'rgba(255, 0, 0, 0.5)',
    'Confidence Interval High': 'rgba(0, 255, 0, 0.5)'
  }

  return (
      <Col>
        <Card
          className={'gapless-x gapless-y'}
          bordered={false}
          title={`Feature: ${feature} | Target: ${target}`}
        >
          <div style={{height: 300, width: 900}}>
            <NivoScatterChart
                data={chartData}
                keys={Object.keys(colorMapping)}
                customColors={colorMapping}
                axisLeftLegend={'Partial Dependence'}
                axisBottomLegend={'Grid (Used for pdep)'}
                dotSize={5}
                xPadding={0.25}
                yPadding={0.1}
            />
          </div>
        </Card>
      </Col>
  )

}


const AttributionModel = ({data})=>{
  return (
      <Row>
        {data.map((x, i)=>{
          return <AttributionPair key={i} feature={x.feature} target={x.target} gridValues={x.grid} pdepValues={x.pdep} confi={x.confi} />
        })}
      </Row>
  )
}



const processRegattrData = (data)=>{
  const barData = [];
  const fields = [];
  for (let key in data){
    const barGroup = {id: key};
    for (let feature in data[key]){
      barGroup[feature] = (data[key][feature] * 100).toFixed(2);
      if (!fields.includes(feature)){
        fields.push(feature);
      }
    }
    barData.push(barGroup);
  }
  return {barData, fields};
}






const AttributionView = ({model})=>{
  const {barData, fields} = processRegattrData(model.sensitivity);
  const {responseId, submitPrompt} = useGptResponses();
  const response = useSelector((state)=>state.gptApi.responses[responseId]);
  const prompt = `Explain the following regularized attribution model scores of each item in the portfolio to factors in simple to understand summary based on this data: ${JSON.stringify(model)}`;

    useEffect(()=>{
      submitPrompt(prompt);
    }, [])



  return (
      <Layout>
        <Row wrap={true}>
          <Col span={8}>
            <Card title={"Factors"}>

            </Card>
          </Col>
          <Col span={16}>
            <Card title={'Impact Summary'}>
              <Row>
                {model.r_squared.map((x, i)=>{
                  return (
                      <Col span={6}>
                        <Progress percent={x*100} type={'circle'} format={(p)=>`${p.toFixed(2)}%`}/>
                      </Col>
                  )
                })}
              </Row>
            </Card>
          </Col>
          <Col span={8}>
            <Card title={"GPT Summary"}>
              {response && response.data}
            </Card>
          </Col>
          <Col span={16}>
            <Card title={'Attribution Breakdown'}>
                    <div style={{height: 400, width:"100%"}}>
                      <NivoBarChart
                          data={barData}
                          keys={fields}
                          vertical={true}
                      />
                    </div>
            </Card>
          </Col>
        </Row>
      </Layout>
  )
}


const DataFetchingComponent = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => selectLatestLargeDataModel(state, 'models/regattr'));
  const loading = useSelector((state) => state.largeDataAnalytics.loading);
  const error = useSelector((state) => state.largeDataAnalytics.error);
  const [featureTickers, setFeatureTickers] = useState(['aapl', 'msft', 'intc', 'nvda']);
  const [showTickerSearch, setShowTickerSearch] = useState(false)

  useEffect(() => {
    dispatch(actions['models/regattr']({features: featureTickers, targets: ['^vix', '^tnx', 'gd=f', '^rut']})).then((response)=>{
        console.log(response);

    })

  }, [dispatch, featureTickers]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error || !model) {
    return <div>Error</div>;
  }
  console.log(model);

  return (
    <div>
      <PageHeader title={'Beta Views'} actions={[
        <Button onClick={()=>setShowTickerSearch(true)}>Search Tickers</Button>
      ]} />
      <AttributionView model={model}/>
      <Modal
          open={showTickerSearch}
          onCancel={()=>{setShowTickerSearch(false)}}
      >
        <TickerSearch onTickersSubmit={(tickers)=>{setFeatureTickers([...featureTickers, ...tickers.map(x=>x.symbol).filter(x=>!featureTickers.includes(x))])}}/>
      </Modal>

    </div>
  );
};

export default DataFetchingComponent